const actionGetPreviousPage = ({commit}) => {
  const page = localStorage.getItem("previous_page");
  commit("SET_PREVIOUS_PAGE", JSON.parse(page));
}

export default {
  actionGetPreviousPage
}